module.exports = {"development":{"graphqlURL":"https://app.lets.events/graphql"},"test":{"graphqlURL":"https://staging.lets.events/graphql"},"production":{"graphqlURL":"https://app.lets.events/graphql"}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/application-resources.json
// module id = 939
// module chunks = 0